<template>
    <gd-modal name="affiliate-funnel-selector-modal" :title="$t('frontend_groovesell_sub_aff_details')" width="600px"
        bg-type="regular">
        <div v-if="funnels.length > 0" style="min-height: 60vh">
            <div>
                <div>
                    <div id="affiliate-links-list-view" class="flex flex-row mt-4">
                        <v-client-table :data="funnels" :columns="funnelSelectorColumns"
                            :options="funnelSelectorTableOptions" @row-click="selectFunnel">
                            <div slot="name" slot-scope="props">
                                <a @click="selectFunnel(props.row)" class="cursor-pointer hover:underline">
                                    {{ props.row.name }}
                                </a>
                            </div>
                        </v-client-table>
                    </div>
                </div>
            </div>
        </div>
    </gd-modal>
</template>
<script>

export default {
    components: {
        //
    },
    props: {
        funnels: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            funnelSelectorColumns: [
                'name',
                'human_readable_processed_without_advances',
            ],
            funnelSelectorTableOptions: {
                headings: {
                    name: this.$t('frontend_groovesell_funnel'),
                    human_readable_processed_without_advances: this.$t('frontend_groovesell_due_comissions'),
                },
                perPage: 10,
                texts: {
                    filterPlaceholder: 'Search',
                    filter: '',
                },
            },
            //
        }
    },
    methods: {
        selectFunnel(funnel) {
            console.log('in', funnel);
            this.$emit('selectFunnel', funnel);
        }
    }
}
</script>
